export { InnerRoot } from '../static/html';
export { registerStaticRootComponent } from '../static/registerRootComponent';
